/*
 * @Description: 经纪人管理
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2021-07-06 18:32:16
 * @LastEditTime: 2023-12-20 18:20:38
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import {
  get,
  post
} from '../index'
export default {
  // 审核列表
  brokerList (querys) {
    return get('coachbroker/admin/AdminBroker/brokerList', querys)
  },
  // 经纪人详情
  brokerInfo (querys) {
    return get('coachbroker/admin/AdminBroker/brokerInfo', querys)
  },
  // 新增经纪人
  brokerAdd (querys) {
    return post('coachbroker/admin/AdminBroker/brokerAdd', querys)
  },
  // 审核/编辑经纪人
  brokerUpdate (querys) {
    return post('coachbroker/admin/AdminBroker/brokerUpdate', querys)
  },
  // 选择用户
  noBrokerUserList (querys) {
    return get('coachbroker/admin/AdminBroker/noBrokerUserList', querys)
  },
  // 数据统计
  brokerDataList (querys) {
    return get('coachbroker/admin/AdminBroker/brokerDataList', querys)
  },
  // 邀请的技-师
  brokerCoachList (querys) {
    return get('coachbroker/admin/AdminBroker/brokerCoachList', querys)
  },
  // 经纪人等级列表
  levelList (querys) {
    return get('coachbroker/admin/AdminBroker/levelList', querys)
  },
  // 经纪人等级详情
  levelInfo (querys) {
    return get('coachbroker/admin/AdminBroker/levelInfo', querys)
  },
  // 新增经纪人等级
  levelAdd (querys) {
    return post('coachbroker/admin/AdminBroker/levelAdd', querys)
  },
  // 编辑经纪人等级
  levelUpdate (querys) {
    return post('coachbroker/admin/AdminBroker/levelUpdate', querys)
  },
  // 配置详情
  configInfo (querys) {
    return get('coachbroker/admin/AdminBroker/configInfo', querys)
  },
  // 配置详情
  configUpdate (querys) {
    return post('coachbroker/admin/AdminBroker/configUpdate', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/coachbroker.js